import React from 'react';
import PropTypes from 'prop-types';
import Form from '../form/Form';

const layout = [
  {
    name: 'items',
    label: 'Pages',
    validation: {
      type: 'page',
    },
    control: 'Tags',
    data: [],
    required: true,
  },
];

const NewItem = ({ onCancel, onSubmit }) => {
  return (
    <div className="new-item">
      <Form layout={[...layout]} exportFormat="object" submit={onSubmit} onCancel={onCancel} trackDirty={false} />
    </div>
  );
};

NewItem.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default NewItem;
